import React from 'react';
import PropTypes from 'prop-types';
import Colours from '../../../../../styles/colours';
import MText from '../../../../../components/Common/MText';

const VoucherDesign = (props) => (
  <div
    className="position-relative"
    style={{
      cursor: 'pointer',
      border: `4px solid ${props.src === props.selectedVoucherDesign
        ? (props.disabled ? Colours.Gray5 : Colours.Secondary)
        : 'transparent'}`,
    }}
    role="button"
    tabIndex={0}
    onKeyDown={props.onClick}
    onClick={props.onClick}
  >
    <img alt="voucher" src={props.src} width={115} height="auto" />
    <div className="position-absolute d-flex" style={{ top: 8, left: '50%', transform: 'translateX(-50%)' }}>
      <img
        alt="page-logo"
        className="rounded-circle"
        src={props.pageLogo}
        width={38}
        height={38}
        style={{ objectFit: 'cover' }}
      />
    </div>
    <div className="position-absolute d-flex flex-column align-items-center w-100" style={{ top: '55%' }}>
      <MText
        bold
        colour={props.colour}
        text="$X Off*"
        style={{
          lineHeight: 1,
          textShadow: `
            -1px 0 0 white,
            0 -1px 0 white,
            1px 0 0 white,
            0 1px 0 white,
            -1px -1px 0 white,
            1px -1px 0 white,
            -1px 1px 0 white,
            1px 1px 0 white`,
        }}
      />
      <MText bold colour={props.colour} size={8} text="No Minimum Spend" style={{ lineHeight: 1 }} />
    </div>
  </div>
);

VoucherDesign.propTypes = {
  src:                   PropTypes.string.isRequired,
  pageLogo:              PropTypes.string.isRequired,
  selectedVoucherDesign: PropTypes.string.isRequired,
  onClick:               PropTypes.func,
  disabled:              PropTypes.bool,
  colour:                PropTypes.string.isRequired,
};

VoucherDesign.defaultProps = {
  disabled: false,
  onClick:  () => {},
};

export default VoucherDesign;
